"use client";

import { ComponentProps } from "react";
import {
  TemplateCard,
  useTemplateDetail,
  useTemplateBookmarkContext as useBaseTemplateBookmarkContext,
} from "@zapier/templates";
import { useSessionContext } from "src/contexts/SessionContext";

export function ZapCard({
  size = "small",
  template,
  clickEventInteractionGoal,
  href,
  onClick,
  tagLabel,
  className,
  renderedImage,
  hasBookmarking,
}: Omit<
  ComponentProps<typeof TemplateCard>,
  "templateBookmarkActions" | "isLoggedIn" | "hasBookmarking"
> & {
  hasBookmarking?: boolean;
}) {
  const bookmarkContext = useBaseTemplateBookmarkContext();

  const { setUseCase, setSlug, setPrimaryProduct } = useTemplateDetail();
  const { session } = useSessionContext();

  // Use hasBookmarking prop if provided, otherwise default to session.is_logged_in
  const shouldShowBookmarking = hasBookmarking ?? session.is_logged_in;

  const handleTemplateClick = () => {
    if (onClick && typeof onClick === "function") {
      onClick();
    } else {
      setUseCase((template.categories || [])[0]?.slug || null);
      setSlug(template.slug);
      setPrimaryProduct(template.primaryProduct || null);
    }
  };

  return (
    <TemplateCard
      clickEventInteractionGoal={clickEventInteractionGoal}
      size={size}
      href={href}
      onClick={handleTemplateClick}
      className={className}
      template={template}
      tagLabel={tagLabel}
      isLoggedIn={session.is_logged_in}
      hasBookmarking={shouldShowBookmarking}
      renderedImage={renderedImage}
      templateBookmarkActions={
        shouldShowBookmarking && bookmarkContext && template.id
          ? {
              onSave: async (id: string) => {
                await bookmarkContext.createUserTemplateBookmark(id);
              },
              onUnsave: bookmarkContext.deleteUserTemplateBookmark,
              isBookmarked: bookmarkContext.isBookmarked(template.id),
              isLoading:
                bookmarkContext.templateBookmarkChanging === template.id,
            }
          : undefined
      }
    />
  );
}
